import { AxiosPromise } from 'axios';
import { EndPointService } from 'src/services/api-handlers/axios';

function getFilesProgramBook(id: any): AxiosPromise {
    return EndPointService.get(`/program_book_docs`, { params: { 'programBook.id': id } });
}

function getProgramBookEntity(id: any, isHidden: any): AxiosPromise {
    return EndPointService.get(`/program_books/${id}?isHidden=${isHidden}`);
}
function getProgramBooks(params: any): AxiosPromise {
    return EndPointService.get('/program_books', { params });
}
function getProgramBooksSmall(params: any): AxiosPromise {
    return EndPointService.get('/pb-simply-list', { params });
}

function getProgramBookAnswers(params: any): AxiosPromise {
    return EndPointService.get('/program_target_answers', { params });
}

function getProgramBookAnswersForPlot(params: any): AxiosPromise {
    return EndPointService.get('/program_target_answers/plot', { params });
}

function getProgramBookAnswersForNotes(params: any): AxiosPromise {
    return EndPointService.get('/program_target_answers/notes', { params });
}

function updateProgramBookAnswers(payload: any): AxiosPromise {
    return EndPointService.post('/program_target_answers', payload);
}

function updateProgramBookAnswerOfTarget(payload: any, target: any): AxiosPromise {
    return EndPointService.post('/program_target_answers?target=' + target, payload);
}

function createProgramBook(payload: any): AxiosPromise {
    return EndPointService.post('/program_books', payload);
}
function createProgramBookFiles(payload: any): AxiosPromise {
    return EndPointService.post('/program_book_docs', payload);
}

function updateProgramBook(id: number | string, payload: any): AxiosPromise {
    return EndPointService.put(`/program_books/${id}`, { ...payload });
}

function autoSaveProgramBook(id: number | string, payload: any): AxiosPromise {
    return EndPointService.put(`/program_books/${id}/auto-save`, { ...payload });
}

function deleteFileProgramBook(id: number | string): AxiosPromise {
    return EndPointService.delete(`/program_book_docs/${id}`);
}

export default {
    getProgramBookEntity,
    createProgramBookFiles,
    deleteFileProgramBook,
    getProgramBooks,
    getFilesProgramBook,
    createProgramBook,
    updateProgramBook,
    autoSaveProgramBook,
    getProgramBookAnswers,
    updateProgramBookAnswers,
    updateProgramBookAnswerOfTarget,
    getProgramBooksSmall,
    getProgramBookAnswersForPlot,
    getProgramBookAnswersForNotes,
};
